"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FeatureEnabled = exports.isFeatureEnabled = void 0;
const tslib_1 = require("tslib");
const createConfig_1 = tslib_1.__importDefault(require("../config/createConfig"));
const isFeatureEnabled = (forFeature, mfeName) => {
    const { config } = (0, createConfig_1.default)();
    const mfeFeatures = config(`features.${mfeName}`);
    return !!mfeFeatures && mfeFeatures[forFeature] === true;
};
exports.isFeatureEnabled = isFeatureEnabled;
const FeatureEnabled = ({ forFeature, mfeName, children, fallback, }) => {
    if ((0, exports.isFeatureEnabled)(forFeature, mfeName)) {
        return children;
    }
    if (fallback) {
        return fallback;
    }
    return null;
};
exports.FeatureEnabled = FeatureEnabled;
//# sourceMappingURL=Features.js.map